<ion-footer>
  <ion-button class="footer-button"
              expand="full"
              [color]="buttonColor"
              [disabled]="disabled" (click)="buttonClicked.emit()">
    {{ buttonText }}
  </ion-button>
</ion-footer>
